import axios from "axios";
import { confirmAlert } from "react-confirm-alert";

type GetServerInsectNameProps = {
    productCodeId: number;
    productCode: string;
    productName: string;
};

const GetServerInsectName = async (): Promise<GetServerInsectNameProps[] | undefined> => {
	try {
		const response = await axios.get<GetServerInsectNameProps[]>("/ifactory/api/productcode");
		return response.data;
	} catch (error:any) {
		confirmAlert({
			title: error.response.data,
			buttons: [{ label: "Yes" }],
		});
	}
};

export default GetServerInsectName;